/*
 * @Author: Lemon C
 * @Date: 2024-12-14 15:05:19
 * @LastEditTime: 2025-11-14 13:08:04
 */
import { defineStore } from 'pinia';
import { createApp, markRaw } from 'vue';
import VideoDialog from '@/components/Video/VideoDialog.vue';

const dialogElement = document.createElement('div');
dialogElement.id = 'id_dialog_Element';

export const useDialogStore = defineStore('dialog', {
    state: () => ({
        dialogInstance: null,
        app: null,
    }),
    actions: {
        showVideoDialog(videoPath) {
            this.createDialog(VideoDialog, videoPath);
        },
        hideVideoDialog() {
            this.dialogInstance.hide_dialog();
            this.destroyDialog();
        },

        createDialog(view, videoPath) {
            // 卸载旧实例
            if (this.app) {
                this.app.unmount();
                document.body.removeChild(dialogElement);
            }
            // 标记 videoPath 为非响应式
            const rawVideoPath = markRaw(videoPath);
            // 创建 App 并标记为非响应式
            this.app = markRaw(createApp(view, { videoPath: rawVideoPath }));
            document.body.appendChild(dialogElement);
            // 挂载后标记实例为非响应式
            this.dialogInstance = markRaw(this.app.mount(dialogElement));
            this.dialogInstance.show_dialog(rawVideoPath);
        },

        destroyDialog() {
            if (this.dialogInstance) {
                this.app.unmount();
                this.dialogInstance = null;
                this.app = null;
                document.body.removeChild(dialogElement);
            }
        },
    },
});
